import {Api} from "../../Api";
import {HttpClient} from "../../_http/HttpClient";

export class FtpSynchronizationAPI {
  static forceSync(payload: { year: number, month: number; }): Promise<Response> {
    const url: string = Api.getUrl('/ftp/synchronization/synchronize');
    return HttpClient.postAndExpectNoContent(url, {}, { ...payload });
  }
}